import moment from 'moment';

export function formatStringDate (stringValue) {
  if (stringValue === null)
    return null;
  return moment(new Date(stringValue)).format('YYYY-MM-DD');
}

export function formatStringDateUserFriendly (stringValue) {
  if (stringValue === null)
    return null;
  return new Date(Date.parse(stringValue)).toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'long'
  });
}

export function formatStringDateUserFriendlyAndGetWeekday (stringValue) {
  if (stringValue === null)
    return null;
  return new Date(Date.parse(stringValue)).toLocaleDateString('ru-RU', {
    weekday: 'short'
  });
}
export function formatStringDateTime (stringDateTime) {
  if (stringDateTime === null)
    return null;
  const asDate = new Date(stringDateTime);
  return `${asDate.toLocaleDateString()}, ${('0' + asDate.getHours()).slice(-2) + ':' + ('0' + asDate.getMinutes()).slice(-2)}`;
}

export function formatCurrency (value, locale) {
  let currency;
  switch (locale) {
    case 'ru':
      currency = 'RUB';
      break;
    case 'kz':
      currency = 'KZT';
      break;
    case 'uz':
      currency = 'UZS';
      break;
    default:
      currency = 'RUB'; // Значение по умолчанию для неизвестного или неопределенного языка
  }

  // Определяем символ валюты вручную
  let currencySymbol;
  switch (currency) {
    case 'RUB':
      currencySymbol = '₽'; // Символ рубля
      break;
    case 'KZT':
      currencySymbol = '₸'; // Символ тенге
      break;
    case 'UZS':
      currencySymbol = 'сум'; // Символ сума
      break;
    default:
      currencySymbol = currency; // Если символ неизвестен, используем код валюты
  }

  // Форматируем сумму с использованием Intl.NumberFormat
  let formattedValue = new Intl.NumberFormat(locale, { style: 'currency', currency: currency, minimumFractionDigits: 0 }).format(value);

  // Перемещаем символ валюты в конец строки, если это необходимо
  if (locale === 'uz') {
    formattedValue = formattedValue.replace(currency, '').trim() + ' ' + currencySymbol;
    formattedValue = formattedValue.replace(',', ' ');
  } 
  else {
    formattedValue = formattedValue.replace(currency, currencySymbol);
  }

  return formattedValue;
}

export function formatCard (value) {
  return new Intl.NumberFormat('ru-RU', { useGrouping: true }).format(value);
}

export const isoDate = (value) => (new Date(value - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
export const isoLocalDateTime = (value) => (new Date(value - (new Date()).getTimezoneOffset() * 60000)).toISOString();

